<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G H Raisoni Memorial Jalna Open Chess Tournament </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G H Raisoni Memorial Jalna Open Chess Tournament </span></h2>
        </div>
        <p><strong>Date:</strong> 11th January 2026</p>
        <p><strong>Venue:</strong> Sri Chaitanya Techno School Manish Nagar Jalna</p>

        <p>The G. H. Raisoni Memorial Jalna Open Chess Tournament 11th January 2026, organized by Glorious Chess Academy
            with G. H. Raisoni, was a grand success. The event witnessed enthusiastic participation with 212 registered
            players
            representing from all over Maharashtra. The total prize fund was ₹ 40,000/-, with the winner receiving ₹
            7,100 + Trophy.
        </p>
        <hr>
        <h5 class="primary-purple">Opening Ceremony:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li>Mr. Sachin Giri, BDM Sri Chaitanya Techno School</li>
            <li>Dr. Aakash Mundada, Charted accountant Jalna</li>
            <li>Mr. Satish Thakur, Joint Secretary Maharashtra Chess Association</li>
            <li>Mr. Aasaram Ghule, RTO Officer Jalna</li>
            <li>IA Pavan K. Rathi, Chief Arbiter and Indian Book of Record Holder</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Tournament Highlights:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>FIDE Format:</strong> Rapid Chess Tournament</li>
            <li><strong>No. of Rounds:</strong> 8 Rounds with Swiss League</li>
            <li><strong>Time Control:</strong> 10 Minutes + 05 Seconds Increment From Move 1</li>
            <li><strong>Participants:</strong> 212 (Where 58 Fide International Rated)</li>
            <li><strong>Female Player:</strong> 34</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Technical Team:</h5>
        <p><strong>Chief Arbiter:</strong> IA Pavan K. Rathi (Indian Book of Record as Organiser)</p>
        <p><strong>Arbiters:</strong></p>
        <ul class="list-style list-style1 mb-3 list-count">
            <li>FA Satish Thakur</li>
            <li>FA Krishna Thakur</li>
            <li>SNA Vilas Rajput</li>
        </ul>
        <p><strong>Assistant:</strong></p>
        <ul class="list-style list-style1 mb-3 list-count">
            <li>Mr. Sujal Thakur</li>
            <li>Mr. Vijay Thakur</li>
            <li>Mr. Mithun Waghmare</li>
            <li>Miss. Sachal Bihani</li>
            <li>Mr. Vishal Shinde</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Closing Ceremony:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li>Mr. Sachin Giri, BDM Sri Chaitanya Techno School</li>
            <li>Dr. Aakash Mundada, Charted accountant Jalna</li>
            <li>Mr. Satish Thakur, Joint Secretary Maharashtra Chess Association</li>
            <li>Mr. Aasaram Ghule, RTO Officer Jalna</li>
            <li>Mr. Prasad Patki, Businessman In Buldhana</li>
            <li>IA Pavan K. Rathi, Chief Arbiter of the tournament.</li>
        </ul>
        <hr>

        <!-- <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/chess-open-tournament-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/chess-open-tournament-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/chess-open-tournament-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div> -->
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>Reports</h4>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-4">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/ghr-jalna-winner-list.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4>Winner List</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/doc20260121-WA0002.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Kalpana Prakash </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/ghr-memorial-jalna-rapid.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> G H Raisoni Memorial Jalna Rapid 2026 </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
